import { MutationOptions, useMutation } from '@tanstack/react-query'
import { deleteBlockConnector } from './requests/delete'

type BlockConnectorDeleteParams = {
  id: string
  blockId: string
}

type OnMutateHandler = (params: BlockConnectorDeleteParams) => void
type OnSuccessHandler = (data: null, params: BlockConnectorDeleteParams) => void

type QueryParams = {
  mutationKey?: MutationOptions['mutationKey']
  onMutate?: OnMutateHandler
  onSuccess?: OnSuccessHandler
}

export function useDeleteBlockConnector({
  mutationKey,
  onMutate,
  onSuccess,
}: QueryParams) {
  return useMutation({
    mutationKey,
    mutationFn: ({ id }: BlockConnectorDeleteParams) =>
      deleteBlockConnector({
        params: {
          path: { block_connector_id: id },
        },
      }),
    onMutate: onMutate,
    onSuccess: onSuccess,
  })
}
